/* Clothing Connect: cart drawer "Add to your order" buttons.
   Loaded once with the page; works on drawer content that is re-rendered later. */
(function () {
  if (window.__ccUpsellBound) return;
  window.__ccUpsellBound = true;

  document.addEventListener('click', async function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-cc-upsell] .cc-upsell__add') : null;
    if (!btn) return;
    event.preventDefault();

    var item = btn.closest('.cc-upsell__item');
    var select = item ? item.querySelector('.cc-upsell__select') : null;
    var variantId = select ? select.value : btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding';

    try {
      if (window.Shopify && window.Shopify.actions && window.Shopify.actions.updateCart) {
        await window.Shopify.actions.updateCart({ lines: [{ merchandiseId: String(variantId), quantity: 1 }] });
      } else {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        window.location.reload();
      }
      btn.textContent = 'Added';
    } catch (e) {
      btn.textContent = original;
      btn.disabled = false;
    }
  });
})();
